import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetFiltersResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/filters/service.types';
import React from 'react';
import {
  FilterFlyout,
  FilterFlyoutProps,
} from '../../../../features/Filters/FilterFlyout/FilterFlyout';
import {FilterFlyoutError} from '../../../../features/Filters/FilterFlyout/FilterFlyoutError';
import {FilterFlyoutLoading} from '../../../../features/Filters/FilterFlyout/FilterFlyoutLoading';
import {FlyoutFilters} from '../../../../features/Filters/FilterFlyout/FlyoutFilters';
import {useCategoryStreamFiltersData} from '../shared/useCategoryStreamFiltersData';

export const CategoryFilterFlyout: React.FC<
  Omit<FilterFlyoutProps, 'FilterContent'>
> = props => {
  return <FilterFlyout FilterContent={FilterContent} {...props} />;
};

const FilterContent: FilterFlyoutProps['FilterContent'] = props => {
  return (
    <DataFetcher
      request={useCategoryStreamFiltersData()}
      Error={FilterFlyoutError}
      Loading={FilterFlyoutLoading}
      viewProps={props}
      View={FilterContentView}
    />
  );
};

const FilterContentView: React.FC<
  Omit<FilterFlyoutProps, 'FilterContent'> & {
    onClose: VoidFunction;
    onPrimaryButtonClick: VoidFunction;
  } & GetFiltersResponse
> = ({filters, ...otherProps}) => {
  return <FlyoutFilters availableFilters={filters} {...otherProps} />;
};
